<template>
  <div class="landing">
    <div class="page-banner">
      <img src="../assets/guitar-landing-banner-opt.png" class="page-banner" />
      <div class="banner-appeal site-text">
        <h1>Musikalische Bildung</h1>
        <div>
          <p>für <strong>alle Altersgruppen</strong>.</p>
          <p>
            Entdecke jetzt unsere Instrumental- und <br />
            Gesangskurse und melde dich <br />
            oder deine Kinder zur unverbindlichen<br />
            <strong>kostenlosen Probestunde</strong> <br />
            an!
          </p>
        </div>
      </div>
      <div class="landing-call-to-action">
        <router-link to="/kurse" tag="button"
          >Unsere Kurse entdecken</router-link
        >
      </div>
    </div>
    <div class="content-about site-text">
      <div class="styled-underline">
        <h2>Unsere Philosophie</h2>
      </div>
      <img src="@/assets/undraw_in_thought_gjsf.svg" />
      <div class="about-box">
        <p>
          Die Kraft der Musik vermag jedem Menschen eine neue Dimension im Leben
          zu eröffnen.
        </p>
        <p>
          In unseren Kursen bieten wir dir eine
          <strong>qualitativ hochwertige musikalische Ausbildung</strong> durch
          unsere hervorragend ausgebildeten sowie musikalisch aktiven Lehrer.
        </p>
        <p>
          Die <strong>Wirkungen der Musik</strong> sind vielfältig und erreichen
          alle unsere Sinne, fördern auf körperlicher Ebene Hirnaktivitäten,
          Konzentrationsvermögen, und
          <a
            class="link ext-link"
            href="https://www.spiegel.de/wissenschaft/mensch/abwehrkraefte-singen-staerkt-die-immunabwehr-a-282605.html"
            target="_blank"
            >stärken u.a. unsere Immunabwehr</a
          >.
          <br />
          Musik ist rundum gesund!<br />
          Unser Angebot bietet jedem die Möglichkeit dies aktiv zu erfahren.
        </p>
      </div>
      <p>
        All diese Gründe haben uns als professionelle Musiker dazu bewegt, hier
        in Schömberg-Langenbrand unsere Musikschule zu eröffnen und damit eine
        musikalische Ausbildungsmöglichkeit auf vielen Instrumenten vor Ort zu
        schaffen.
      </p>
      <div class="testimonial content-about-testimonial">
        <div class="testimonial-quote">
          <span>“</span>Musik hat die Kraft eine eigene Dimension im Leben zu
          eröffnen. Es ist uns wichtig in unseren Kursen nicht nur eine
          qualitativ hochwertige musikalische Ausbildung sicherzustellen,
          sondern auch Spaß und Lebensfreude zu vermitteln.<span>”</span>
        </div>
        <div class="testimonial-person">
          <img src="@/assets/portrait/heidrunmariahahn.png" />
          <div class="testimonial-person-name">Heidrun Maria Hahn</div>
          <div class="testimonial-person-description">
            Stellv. Schulleiterin, Opernsängerin, Lehrkraft Gesang
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home"
};
</script>

<style lang="scss">
.page-banner {
  display: block;
  height: 750px;
  width: 1250px;
  position: relative;

  @media only screen and (max-width: 1280px) {
    width: 100%;
    height: auto;
  }
}

img.page-banner {
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(
    165deg,
    hsl(0, 0%, 100%) 45%,
    hsla(269, 77%, 92%, 1) 99%
  );

  @media only screen and (max-width: 1280px) {
    display: none;
  }
}

.banner-appeal {
  position: absolute;
  top: 175px;
  left: 60px;
  > h1 {
    margin-bottom: 0px;
  }
  div > p:first-child {
    margin-top: 0px;
  }

  @media only screen and (max-width: 1280px) {
    position: relative;
    top: 50px;
    left: 0;
    margin: 0 30px;
  }
}

.landing-call-to-action {
  position: absolute;
  top: 570px;
  left: 60px;
  @media only screen and (max-width: 1280px) {
    position: relative;
    top: 10px;
    left: 30px;
  }
}

.content-about {
  width: 1250px;
  background: #fff;
  padding: 55px 60px;
  background: linear-gradient(200deg, white 45%, hsla(269, 76%, 94%, 1) 99%);

  @media only screen and (max-width: 1280px) {
    width: 100%;
    padding: 60px 30px;
  }

  h2 {
    margin-top: 0px;
  }
  > img {
    width: 350px;
    margin-right: 50px;
    vertical-align: top;
    margin-bottom: 10px;

    @media only screen and (max-width: 1280px) {
      width: calc(100% - 30px);
      margin: 0;
    }
  }
  .about-box {
    display: inline-block;
    max-width: 700px;
    > p:first-child {
      margin-top: 0;
    }
  }
  .content-about-testimonial {
    margin-top: 60px;
    margin-bottom: 30px;
  }
}
</style>
